import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import BreakdownContainer from '../BreakdownContainer';
import lang from '../language.json';
import SingleLineValue from '../styles/SingleLineValue';

type VABenefitCalculationBreakdownProps = {
  selectedResult: CalculationResult;
  onNewWindow?: () => void;
  hideAccordion?: boolean;
};

export default function VABenefitCalculationBreakdown({
  selectedResult,
  onNewWindow,
  hideAccordion,
}: Readonly<VABenefitCalculationBreakdownProps>) {
  const formulas = selectedResult.formulas ?? [];

  const equation = formulas.find(({ formula }) => formula?.trim())?.formula;

  return (
    <BreakdownContainer
      header={lang.HEADERS[selectedResult.calculatorTypeId]}
      onNewWindow={onNewWindow}
      hideAccordion={hideAccordion}
    >
      <SingleLineValue
        title={lang.MONTHLY_CALC_EQUATION}
        value={'(Monthly Amount) * 1.25'}
      />
      {equation && (
        <SingleLineValue title={lang.CALCULATION} value={equation} />
      )}
      <SingleLineValue
        title={lang.MONTHLY_INCOME}
        value={selectedResult.calculationAmount}
        isCurrency
      />
    </BreakdownContainer>
  );
}
